module.exports = __webpack_public_path__ + "img/business_13.7f0703b7.jpg";